define 'controller/PromoBannerController', ['jquery', 'lib/kryptonite', 'custom/media-query', 'lib/cookie'], ($, mq) ->
  class PromoBannerController

    constructor: (@$el) ->
      @_closePromotionsBanner()
      @_submitAdvantage()

    _closePromotionsBanner: ->
      $(@$el).on 'click', '.promo_banner .close', (e) ->
        $.cookie('hide_pb', 1, {expires: 1, path: "/"})
        $("#promotion-banner").html("");

    _submitAdvantage: ->
      $(@$el).on 'click', '.promo_banner_submit', (e) ->
        $self = $(@)
        $.kryptonite
          url: "/promo-banner/advantage"
          type: "POST"
          data:
            code: $self.data("code")
          success: ->
            $.cookie('hide_pb', 1, {expires: 1, path: "/"})
            $self.hide()
            $self.parent().find(".promo_banner_success").show();